import _extends from "@babel/runtime/helpers/extends";
import { X } from "lucide-react";
import React from "react";
import { BaseClearButton } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CustomClearButton(innerProps) {
  return /*#__PURE__*/_jsx(BaseClearButton, _extends({}, innerProps, {
    children: /*#__PURE__*/_jsx(X, {
      size: "1rem",
      color: "currentColor"
    })
  }));
}
export default CustomClearButton;